// React
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';

// Yup validation
import * as Yup from 'yup';
import { useFormik } from 'formik';

// Containers Injection
import { notifyError } from '../../containers/componentsInjection';
import { ReportsInjection } from '../../containers/reportsInjection';

// Utils
import { useLoading } from '../../../../hook/useLoading';
import { createData } from '../../../../utils/createData';
import { APIClient } from '../../../../helpers/api_helper';

// View
import { ProposalsByOrganizationPage } from './view';
import { openPdfWithBase64 } from '../../../../utils/openPdfWithBase64';

export const ProposalsByOrganization = () => {
  const [statusOptions, setStatusOptions] = useState([]);

  const { organizations, getOrganizations } = ReportsInjection();
  const notesStorageKey = '@prosmed:notes';

  const [valuesTemp, setValuesTemp] = useState({});

  const api = new APIClient();
  const history = useHistory();
  const { toggleLoading, setLoading } = useLoading();

  const dataCadastralStatus = useMemo(
    () => [
      {
        value: '1',
        label: 'Contratado',
      },
      {
        value: '2',
        label: 'Efetivo',
      },
      {
        value: '3',
        label: 'Aposentado',
      },
      {
        value: '4',
        label: 'Cancelado',
      },
      {
        value: '5',
        label: 'Inativo',
      },
      {
        value: 0,
        label: 'Outros',
      },
    ],
    []
  );

  const dataReportType = useMemo(
    () => [
      {
        value: 'r',
        label: 'Resumido',
      },
      {
        value: 'd',
        label: 'Detalhado',
      },
    ],
    []
  );

  const getProposalStatus = useCallback(async () => {
    await api.get('/proposal/get-status').then((status) => {
      setStatusOptions(createData(status));
    });
  }, []);

  const notesStorage =
    localStorage.getItem(notesStorageKey) ||
    'LISTAGEM DOS SERVIDORES QUE TÊM O DESCONTO PROSMED EM SEUS RESPECTIVOS CONTRACHEQUES, REFERENTE AO MÊS DE JANEIRO DE 2025.';

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      periodStarts: valuesTemp.periodStarts || '',
      periodEnds: valuesTemp.periodEnds || '',
      periodType: valuesTemp.periodType || 'sale',
      reportType: valuesTemp.reportType || {
        value: 'd',
        label: 'Detalhado',
      },
      organizationInput: valuesTemp.organizationInput || [],
      proposalSituationInput: valuesTemp.proposalSituationInput || [],
      employeeSituationInput: valuesTemp.employeeSituationInput || null,
      notes: notesStorage || '',
    },
    validationSchema: Yup.object({
      periodStarts: Yup.string(),
      periodEnds: Yup.string(),
      periodType: Yup.string(),
      reportType: Yup.object().shape({
        label: Yup.string(),
        value: Yup.string(),
      }),
      organizationInput: Yup.array(),
      employeeSituationInput: Yup.array().of(
        Yup.object()
          .shape({
            label: Yup.string(),
            value: Yup.string(),
          })
          .required()
      ),
      proposalSituationInput: Yup.array(),
      notes: Yup.string(),
    }),

    onSubmit: (values) => {
      let proposalStatusArray = values.proposalSituationInput.map((item) => {
        return item.value;
      });

      let cadastralStatusArray = values.employeeSituationInput.map((item) => {
        return item.value;
      });

      let organizationsArray = values.organizationInput.map((item) => {
        return item.value;
      });

      const valuesToSubmit = {
        starts: values.periodStarts || null,
        ends: values.periodEnds || null,
        periodType: values.periodType || null,
        reportType: values.reportType.value || null,
        organization_id: organizationsArray || null,
        proposal_status_id: proposalStatusArray || null,
        cadastral_status: cadastralStatusArray || null,
        notes: values.notes || null,
      };

      localStorage.setItem(notesStorageKey, values.notes);
      setValuesTemp(values);

      toggleLoading();
      api
        .create('/reports/proposal/by-organization', valuesToSubmit)
        .then((response) => {
          openPdfWithBase64(response.data, 'Proposta por Organização');
        })
        .catch((error) => {
          notifyError(error.response.data.messages.error);
        })
        .finally(() => {
          setLoading(false);
        });
    },
  });

  useEffect(() => {
    getOrganizations();
    getProposalStatus();
  }, []);

  return (
    <ProposalsByOrganizationPage
      history={history}
      createData={createData}
      validation={validation}
      // Data
      organizations={organizations || []}
      statusOptions={statusOptions || []}
      dataReportType={dataReportType}
      dataCadastralStatus={dataCadastralStatus}
    />
  );
};
